'use strict';
var getBuiltIn = require('../internals/get-built-in');

module.exports = getBuiltIn('document', 'documentElement');



//////////////////
// WEBPACK FOOTER
// ./~/handsontable/~/core-js/internals/html.js
// module id = 471
// module chunks = 0